<template>
<div class="test-content">
    <div class="symptoms-test-results-container check-symptoms-details">
        <div class="symptoms-test-results">
            <h4>Bolesti koje se podudaraju sa Vašim simptomima</h4>
            <button class="test-results-button blueButton">Tumačenje rezultata</button>

            <div class="matching-illness-container">
                <div 
                    v-for="(item, index) in testResults" 
                    :key="item.id"
                    v-show="index < 3 || showAllResults"
                    v-bind:class="{ selected: selectedCondition.id === item.id }"
                    @click="selectedCondition = item"
                    class="matching-illness" 
                    id="first-matching-illness">
                    <div class="matching-illness-wrapper">
                        <h6>{{ item.name }}</h6>
                    </div>
                    <div class="matching-illness-arrow">
                        <img src="/images/medik/matching-illness-arrow.png" alt="arrow" />
                    </div>
                </div>
            </div>
            <button 
                @click="showAllResults = true"
                v-show="!showAllResults && testResults.length > 3"
                class="more-matching-illness-btn blueButton">
                Još rezultata
            </button>
        </div>
        <div v-if="selectedCondition" class="symptoms-test-results-description">
            <h5>{{ selectedCondition.name }}</h5>
            <ul class="test-results-description-breadcrumbs">
                <li v-bind:class="{ active: activeStep === 4 }" @click="onChangeTab(4, $event)">
                    <a href="#">Detalji</a>
                </li>
                <li v-bind:class="{ active: activeStep === 5 }" @click="onChangeTab(5, $event)">
                    <a href="#">Lečenje</a>
                </li>
            </ul>
            <div class="details-info-content" v-if="activeStep === 4 && selectedCondition">
                <div v-show="selectedCondition.symptoms.length > 0" class="test-results-description-section">
                    <h6>Simptomi</h6>
                    <p>{{ formattedSymptoms }}</p>
                </div>
                <div v-show="selectedCondition.description" class="test-results-description-section">
                    <h6>Opis</h6>
                    <p>{{ trimmedConditionDescription }}</p>
                </div>
            </div>
            <div class="treatment-info-content" v-if="activeStep === 5 && selectedCondition">
                <div v-show="selectedCondition.treatments.length > 0" class="test-results-description-section">
                    <h6>Tretmani</h6>
                    <p>{{ formattedTreatments }}</p>
                </div>
                <div v-show="selectedCondition.nf_treatments.length > 0" class="test-results-description-section">
                    <h6>Nefarmaceutski tretmani</h6>
                    <p>{{ formattedNfTreatments }}</p>
                </div>
                <div v-show="selectedCondition.prevention" class="test-results-description-section">
                    <h6>Prevencija</h6>
                    <p v-html="selectedCondition.prevention"></p>
                </div>
            </div>

            <a 
                class="blueButton test-results-description-btn" 
                :href="redirectUrl"
                target="_blank">
                Detaljnije
            </a>
        </div>
    </div>
</div>
</template>

<script>
let baseUrl = process.env.MIX_PUBLIC_API_BASE_URL;
export default {
    name: 'FourthStepDetails',
    components: {
    },

    props: ['activeStep', 'testResults', 'firstItem'],

    data(){
        return {
            selectedCondition: this.firstItem,
            showAllResults: false,
        }
    },

    methods: {
        onChangeTab(activeStep, event) {
            event.preventDefault();
            this.$emit('tabChanged', activeStep);
        }
    },

    computed: {
        formattedSymptoms: function () {
            if (this.selectedCondition) {
                return this.selectedCondition.symptoms.map(function(symptom) {
                    return symptom.name;
                }).join(', ');
            }
            return '';
        },
        formattedTreatments: function () {
            if (this.selectedCondition) {
                return this.selectedCondition.treatments.map(function(treatment) {
                    return treatment.name;
                }).join(', ');
            }
            return '';
        },
        formattedNfTreatments: function () {
            if (this.selectedCondition) {
                return this.selectedCondition.nf_treatments.map(function(treatment) {
                    return treatment.name;
                }).join(', ');
            }
            return '';
        },
        redirectUrl: function() {
            return this.selectedCondition ? `${baseUrl}/bolesti/${this.selectedCondition.slug}-${this.selectedCondition.id}` : '';
        },
        trimmedConditionDescription: function() {
            let handlerDiv = document.createElement("div");
            handlerDiv.innerHTML = this.selectedCondition.description;
            let paragraphs = handlerDiv.getElementsByTagName('p');
            let firstParagraph = paragraphs.length > 0 ? paragraphs[0] : null;
            if (!firstParagraph) {
                return "";
            }
            if (firstParagraph.textContent.length <= 400) {
                return firstParagraph.textContent;
            }
            
            return firstParagraph.textContent.substr(0, firstParagraph.textContent.lastIndexOf(' ', 400)) + '...';
        }
    },

    watch: {
        firstItem: function(val, oldVal) {
            this.selectedCondition = val;
            this.showAllResults = false;
        },
    }
  
}
</script>

<style>
</style>